module.exports = __webpack_public_path__ + "static/media/signal-0.41156b27.svg";